import axios from 'axios'
import http from '@/communication/AuthConnection'

const CancelToken = axios.CancelToken
let source = false

export default ({ params }) => {
  if (source) {
    source.cancel('cancel request')
  }

  source = CancelToken.source()
  const cancelToken = source.token

  return http.get('/v1/event',
    {
      params,
      cancelToken
    })
    .then(pData => pData.data)
    .catch(() => { return [] })
}



// WEBPACK FOOTER //
// ./src/brain/event/ListEvent.js